/** Keep in sync with backend/src/utils/emailHtml.js sanitizeSignatureHtml. */
export function sanitizeSignatureHtml(html: string): string {
  let value = String(html ?? '').replace(/\u0000/g, '')
  let previous = ''
  while (value !== previous) {
    previous = value
    value = value.replace(/<script\b[^>]*>[\s\S]*?<\/script\s*>/gi, '')
    value = value.replace(/<script\b[^>]*>[\s\S]*$/gi, '')
  }
  value = value.replace(
    /(^|[\s/])on[a-z][a-z0-9:-]*\s*=\s*(?:"[\s\S]*?"|'[\s\S]*?'|[^\s"'=<>`]+)/gi,
    '$1',
  )
  return value.trim()
}

export function signaturePreviewDocument(html: string): string {
  const safe = sanitizeSignatureHtml(html)
  return `<!DOCTYPE html><html><head><meta charset="utf-8"></head><body>${safe}</body></html>`
}
